import { render, staticRenderFns } from "./CarrierDetailPage.vue?vue&type=template&id=06c7ffc1&scoped=true"
import script from "./CarrierDetailPage.vue?vue&type=script&lang=js"
export * from "./CarrierDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CarrierDetailPage.vue?vue&type=style&index=0&id=06c7ffc1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7ffc1",
  null
  
)

export default component.exports